import { post } from "@/utils/utils";
import moment from "moment";
 
const order = {
  state: {
    orderList: {
      list: [],
      total: 0
    },
    outputCode: "",
    orderDetail: {
      memberInfo: {
        guiderName: "",
        mobilePhone: "",
        realName: "",
        storeOutlet: "",
        workNum: ""
      },
      orderInfo: {
        addTime: "",
        orderId: "",
        payTime: "",
        payType: "",
        status: ""
      },
      priceInfo: {
        totPrice: 0
      },
      productInfo: []
    }
  },
  mutations: {
    ORDER_LIST(state, data) {
      state.orderList = data.result.model;
      state.orderList.list.forEach(v => {
        v.addTimeFormat = v.addTime
          ? moment(v.addTime).format("YYYY-MM-DD HH:mm:ss")
          : "";
        v.payTimeFormat = v.payTime
          ? moment(v.payTime).format("YYYY-MM-DD HH:mm:ss")
          : "";
        switch (v.payType) {
          case 0:
            v.payTypeFormat = "微信支付";
            break;
          case 1:
            v.payTypeFormat = "钱包支付";
            break;
          default:
            break;
        }
        switch (v.status) {
          case 0:
            v.statusFormat = "未支付";
            break;
          case 1:
            v.statusFormat = "已支付";
            break;
          default:
            break;
        }
      });
    },
    ORDER_DETAIL(state, data) {
      state.orderDetail = data.result;
      state.orderDetail.orderInfo.addTimeFormat = state.orderDetail.orderInfo
        .addTime
        ? moment(state.orderDetail.orderInfo.addTime).format(
            "YYYY-MM-DD HH:mm:ss"
          )
        : "";
      state.orderDetail.orderInfo.payTimeFormat = state.orderDetail.orderInfo
        .payTime
        ? moment(state.orderDetail.orderInfo.payTime).format(
            "YYYY-MM-DD HH:mm:ss"
          )
        : "";
      switch (state.orderDetail.orderInfo.payType) {
        case 0:
          state.orderDetail.orderInfo.payTypeFormat = "微信支付";
          break;
        case 1:
          state.orderDetail.orderInfo.payTypeFormat = "钱包支付";
          break;
        default:
          break;
      }
      switch (state.orderDetail.orderInfo.status) {
        case 0:
          state.orderDetail.orderInfo.statusFormat = "未支付";
          break;
        case 1:
          state.orderDetail.orderInfo.statusFormat = "已支付";
          break;
        default:
          break;
      }
    },
    OUTPUT_ORDER(state, data) {
      state.outputCode = data;
    }
  },
  actions: {
    outputOrder({ commit }, params) {
      return post({
        commit,
        url: `/server-back/order_export`,
        name: "OUTPUT_ORDER",
        params
      });
    },
    queryOrderList({ commit }, params) {
      return post({
        commit,
        url: `/server-back/order_info_list`,
        name: "ORDER_LIST",
        params
      });
    },
    queryOrderDetail({ commit }, params) {
      return post({
        commit,
        url: `/server-back/order_detail`,
        name: "ORDER_DETAIL",
        params
      });
    }
  }
};

export default order;
